export interface StoreFeatures {
  canGetProducts: boolean
  canCreateProduct: boolean
  canDeleteRemoteProduct: boolean
  canAutopay: boolean
  canAutocancel: boolean
  canAutoship: boolean
}

const STORES_WITH_PRODUCTS = ['shopify', 'etsy', 'squarespace', 'bigcartel']
const STORES_WITH_PRODUCT_CREATION = ['shopify', 'etsy', 'squarespace']
const STORES_WITH_REMOTE_DELETE = ['shopify', 'etsy', 'squarespace']
const STORES_WITH_AUTOPAY = ['shopify', 'etsy', 'squarespace', 'bigcartel']
const STORES_WITH_AUTOCANCEL = ['shopify', 'squarespace']
const STORES_WITH_AUTOSHIP = ['etsy', 'bigcartel']

export default function getStoreFeatures(store: string): StoreFeatures {
  return {
    canGetProducts: STORES_WITH_PRODUCTS.includes(store),
    canCreateProduct: STORES_WITH_PRODUCT_CREATION.includes(store),
    canDeleteRemoteProduct: STORES_WITH_REMOTE_DELETE.includes(store),
    canAutopay: STORES_WITH_AUTOPAY.includes(store),
    canAutocancel: STORES_WITH_AUTOCANCEL.includes(store),
    canAutoship: STORES_WITH_AUTOSHIP.includes(store),
  }
}
